module.exports = __webpack_public_path__ + "img/writing_beige.404596e.png";